module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 20\"><defs><style>.a{fill:#0061a5;}</style></defs><title>43-Lock-A</title><circle class=\"a\" cx=\"7\" cy=\"14.5\" r=\"1.5\"/><path class=\"a\" d=\"M17,11V7A5,5,0,0,0,7,7v4a2,2,0,0,0-2,2v7a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11ZM9,7a3,3,0,0,1,6,0v4H9ZM7,20V13H17v7Z\" transform=\"translate(-5 -2)\"/></svg>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/lock.svg
// module id = 805
// module chunks = 1